// Reconstructed from production code; original paths and local names were not available.
import { MEDIA_BASE_URL } from "../services/config.js";
import React from "react";
import { api } from "../services/api.js";
import * as jsxRuntime from "react/jsx-runtime";
import { useLanguage } from "../context/LanguageContext.jsx";
function PartnersStrip({ compact: l = false }) {
  const { language: language } = useLanguage(),
    [c, s] = React.useState([]),
    [d, f] = React.useState(true);
  React.useEffect(() => {
    async function p() {
      try {
        const b = await api.get("/partners");
        s(b.data || []);
      } catch (b) {
        console.error("Error loading partners strip", b);
      } finally {
        f(false);
      }
    }
    p();
  }, []);
  const m = c.slice(0, 12),
    y = [];
  for (; m.length && y.length < 6;) y.push(...m);
  const g = [...y, ...y];
  return d || !m.length ? null : (
    <section
      className={
        "partners-strip-wrapper" + (l ? " partners-strip-wrapper--compact" : "")
      }
    >
      <div
        className={"partners-strip"}
        aria-label={language === "ar" ? "شعارات العلامات" : "Brand logos"}
      >
        <div className={"partners-strip-track"}>
          {g.map((p, b) => {
            const x = p.photo_url?.startsWith("http")
              ? p.photo_url
              : `${MEDIA_BASE_URL}${p.photo_url}`;
            return (
              <div
                className={"partners-strip-item"}
                aria-hidden={b >= y.length ? "true" : void 0}
                key={`${p.id}-${b}`}
              >
                <div className={"partners-strip-logo"}>
                  <img
                    src={x}
                    alt={""}
                    aria-hidden={"true"}
                    loading={"lazy"}
                    decoding={"async"}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
export { PartnersStrip };
